import { Component, Input } from '@angular/core';
import { MunilyTooltipPosition } from './tooltip.types';

@Component({
  selector: 'common-tooltip',
  templateUrl: './tooltip.component.html',
  styleUrls: ['./tooltip.component.scss'],
})
export class TooltipComponent {
  @Input() text: string = '';
  @Input() position: MunilyTooltipPosition = 'above';
  @Input() disabled: boolean = false;
  @Input() icon: string = 'info';
}
